// ヨーロッパの世界史スポット。先史の洞窟壁画からエーゲ文明・ギリシア・ローマ、
// 中世キリスト教世界とイスラーム支配下のイベリア、ルネサンスと宗教改革、絶対王政、
// 市民革命と産業革命、そして20世紀の戦争と冷戦までを一続きにたどれるよう選んだ。
//
// アウシュヴィッツは追悼施設のため ○×クイズを付けない。

export const EUROPE_SITES = [
  {
    id: 'lascaux',
    name: 'ラスコー洞窟',
    nameEn: 'Lascaux Cave',
    lat: 45.0492, lng: 1.1706, elevationM: 185,
    region: 'europe', era: 'prehistory',
    country: 'フランス（ドルドーニュ県）',
    civilization: '後期旧石器時代（クロマニョン人）',
    yearLabel: '前17000年頃',
    whcYear: 1979,
    whcNote: '「ヴェゼール渓谷の先史時代遺跡群と装飾洞窟群」の一部',
    emoji: '🐂',
    facts: [
      { label: '現況', value: '保存のため本物は非公開。近くの複製施設を公開' },
    ],
    summary:
      '1940年に少年たちが偶然発見した洞窟で、壁面には牛・馬・鹿など数百点の動物が、赤や黒の顔料で生き生きと描かれている。描かれたのは前17000年頃、後期旧石器時代のクロマニョン人によるもの。狩猟の成功を祈る呪術だったとする説が長く唱えられてきたが、確かなことは分かっていない。同時期のスペインのアルタミラ洞窟とともに、人類がすでに高度な象徴表現の能力を備えていたことを示す。公開による劣化が進んだため本物は閉ざされ、現在は精巧な複製が公開されている。',
    quiz: {
      statement: 'ラスコー洞窟の壁画は農耕が始まったあとの新石器時代に描かれた。',
      answer: false,
      explain: '前17000年頃、農耕が始まる以前の後期旧石器時代の作品です。当時の人々は狩猟と採集で暮らしていました。',
    },
  },
  {
    id: 'stonehenge',
    name: 'ストーンヘンジ',
    nameEn: 'Stonehenge',
    lat: 51.1789, lng: -1.8262, elevationM: 100,
    region: 'europe', era: 'prehistory',
    country: 'イギリス（ウィルトシャー）',
    civilization: '新石器〜青銅器時代',
    yearLabel: '前3000年頃〜前1600年頃（数期にわたる）',
    whcYear: 1986,
    emoji: '🪨',
    summary:
      'イングランド南部の平原に、前3000年頃から千数百年をかけて幾度も造り替えられた環状列石。最大の石は30トンを超え、内側の青みがかった石はおよそ200km離れたウェールズから運ばれたと考えられている。夏至の日の出、冬至の日の入りの方向と軸が一致することから、天体の運行と結びついた祭祀の場だったとみられる。金属器を持たない社会が、広域の協力によってこれほどの構造物を築いた事実は、先史時代の社会が想像以上に組織化されていたことを示している。',
    quiz: {
      statement: 'ストーンヘンジの軸は、夏至の日の出の方向とほぼ一致している。',
      answer: true,
      explain: '主軸は夏至の日の出、および冬至の日の入りの方向に向いています。天体の運行を観測し祭祀に結びつけていたと考えられています。',
    },
  },
  {
    id: 'knossos',
    name: 'クノッソス宮殿',
    nameEn: 'Palace of Knossos',
    lat: 35.2980, lng: 25.1630, elevationM: 85,
    region: 'europe', era: 'ancient',
    country: 'ギリシア（クレタ島）',
    civilization: 'ミノア（クレタ）文明',
    yearLabel: '前1900年頃〜前1400年頃',
    whcYear: null,
    emoji: '🏛',
    summary:
      'クレタ島に栄えたミノア文明の中心となった宮殿。複雑に入り組んだ間取りは、ミノタウロスを閉じ込めた迷宮の伝説を生んだ。壁画にはイルカや百合、牛跳びの儀礼が明るい色彩で描かれ、城壁を持たないことから、海上交通を握って戦争の脅威が小さかった社会像がうかがえる。20世紀初めにイギリスのエヴァンズが発掘した。使われた線文字Aは未解読で、次のミケーネ文明が用いた線文字Bはヴェントリスによってギリシア語と解読された。ヨーロッパ最初期の文明である。',
    quiz: {
      statement: 'クレタ文明で使われた線文字Aは、すでに解読されている。',
      answer: false,
      explain: '線文字Aは未解読です。解読されたのは、続くミケーネ文明の線文字Bで、20世紀半ばにヴェントリスがギリシア語を表すことを突き止めました。',
    },
  },
  {
    id: 'mycenae',
    name: 'ミケーネの獅子門',
    nameEn: 'Lion Gate, Mycenae',
    lat: 37.7306, lng: 22.7564, elevationM: 270,
    region: 'europe', era: 'ancient',
    country: 'ギリシア（ペロポネソス）',
    civilization: 'ミケーネ文明',
    yearLabel: '前1600年頃〜前1200年頃',
    whcYear: 1999,
    whcNote: '「ミケーネとティリンスの考古遺跡」',
    emoji: '🦁',
    summary:
      'ギリシア本土に興ったミケーネ文明の中心的な城塞で、巨石を積んだ城壁と、二頭の獅子を彫った門で知られる。海洋的で開放的なクレタ文明とは対照的に、戦闘的で城塞を重んじる社会だった。線文字Bの粘土板が示すのは、王が農産物や職人を細かく管理する官僚的な統治である。シュリーマンはここで黄金のマスクを発見し「アガメムノンの顔を見た」と伝えたが、実際にはより古い時代のものだった。前1200年頃、「海の民」の動乱とともに崩壊し、ギリシアは暗黒時代に入る。',
    quiz: {
      statement: 'ミケーネ文明が使った線文字Bは、ギリシア語を記したものであることが解読されている。',
      answer: true,
      explain: '1952年にイギリスのヴェントリスが線文字Bを解読し、それが初期のギリシア語であることを示しました。ミケーネ人がギリシア語話者だった証拠です。',
    },
  },
  {
    id: 'parthenon',
    name: 'パルテノン神殿（アクロポリス）',
    nameEn: 'Parthenon, Acropolis',
    lat: 37.9715, lng: 23.7267, elevationM: 150,
    region: 'europe', era: 'ancient',
    country: 'ギリシア（アテネ）',
    civilization: 'アテネ（古典期ポリス）',
    yearLabel: '前447〜前438年',
    whcYear: 1987,
    emoji: '🏛',
    summary:
      'ペルシア戦争でいったん破壊されたアクロポリスに、前447年から再建された女神アテナの神殿。ペリクレスの指導のもと、デロス同盟の資金を投じて建てられた。柱を微妙に膨らませ、基壇をわずかに湾曲させるといった視覚補正の技法が凝らされ、ドーリア式建築の完成形とされる。同じ時期のアテネでは、成年男性市民が民会で直接に政治を決める民主政が最盛期を迎え、悲劇や哲学が花開いた。ただし女性・在留外国人・奴隷は参政権を持たなかったことも忘れてはならない。',
    quiz: {
      statement: '古代アテネの民主政では、女性や奴隷を含むすべての住民に参政権があった。',
      answer: false,
      explain: '参政権を持ったのは成年男性市民に限られ、女性・在留外国人（メトイコイ）・奴隷は除かれていました。人口の一部による直接民主政です。',
    },
  },
  {
    id: 'colosseum',
    name: 'コロッセオ',
    nameEn: 'Colosseum',
    lat: 41.8902, lng: 12.4922, elevationM: 20,
    region: 'europe', era: 'ancient',
    country: 'イタリア（ローマ）',
    civilization: 'ローマ帝国',
    yearLabel: '80年 完成',
    whcYear: 1980,
    whcNote: '「ローマ歴史地区」の一部',
    emoji: '🏛',
    facts: [
      { label: '収容', value: '約5万人' },
    ],
    summary:
      'ウェスパシアヌス帝が着工し、80年にティトゥス帝が完成させた円形闘技場。約5万人を収容し、剣闘士競技や猛獣狩りが行われた。皇帝が市民に無償の穀物と娯楽を与える「パンとサーカス」の舞台であり、詩人ユウェナリスはそこに市民の政治的関心の衰えを見た。コンクリートとアーチ、ヴォールトを駆使した構造は、実用性を重んじたローマ建築の到達点である。石材はのちの建築に転用されて姿を変えたが、法・道路・水道と並ぶローマの遺産としてヨーロッパ文明の基層をなしている。',
    quiz: {
      statement: 'コロッセオが完成したのは共和政ローマの時代である。',
      answer: false,
      explain: '完成は80年、帝政期のティトゥス帝の治世です。共和政は前27年にオクタウィアヌスがアウグストゥスの称号を得た時点で、事実上終わっています。',
    },
  },
  {
    id: 'pompeii',
    name: 'ポンペイ遺跡',
    nameEn: 'Pompeii',
    lat: 40.7497, lng: 14.4869, elevationM: 30,
    region: 'europe', era: 'ancient',
    country: 'イタリア（カンパニア州）',
    civilization: 'ローマ帝国',
    yearLabel: '79年 ヴェスヴィオ火山の噴火で埋没',
    whcYear: 1997,
    emoji: '🌋',
    summary:
      'ナポリ近郊の地方都市が、79年のヴェスヴィオ火山の噴火によって一夜で火山灰の下に埋もれた。灰が空気を遮ったため、フォルムや浴場、パン屋、居酒屋の落書きに至るまでが当時のまま保存され、ローマ帝国の地方都市の日常を細部まで知ることができる稀有な遺跡となった。石膏を流し込んで作られた犠牲者の像は、最期の姿を生々しく伝える。18世紀に本格的な発掘が始まると、その古典的な意匠はヨーロッパの新古典主義美術に大きな刺激を与えた。',
    quiz: {
      statement: 'ポンペイは溶岩流に飲み込まれて焼き尽くされたため、街の姿はほとんど残らなかった。',
      answer: false,
      explain: '実際には火砕流と厚い火山灰に短時間で埋もれ、空気が遮られたことで建物・壁画・落書きまでが保存されました。ローマの地方都市の日常を知る第一級の資料です。',
    },
  },
  {
    id: 'aachen-cathedral',
    name: 'アーヘン大聖堂',
    nameEn: 'Aachen Cathedral',
    lat: 50.7746, lng: 6.0839, elevationM: 175,
    region: 'europe', era: 'medieval',
    country: 'ドイツ（ノルトライン＝ヴェストファーレン州）',
    civilization: 'フランク王国（カロリング朝）',
    yearLabel: '805年 献堂',
    whcYear: 1978,
    emoji: '⛪',
    summary:
      'カール大帝が宮廷を置いたアーヘンに建てた宮廷礼拝堂を核とする聖堂で、1978年に登録された最初期の世界遺産のひとつ。八角形の内陣はビザンツのラヴェンナの聖堂に倣ったもので、古代ローマの再興を掲げたカロリング・ルネサンスの気運を映している。800年、カール大帝はローマ教皇レオ3世から西ローマ皇帝の帝冠を受けた。ゲルマンの王権とローマの伝統、キリスト教会が結びついたこの出来事は、西ヨーロッパ世界が東のビザンツやイスラーム世界と別の道を歩み出す画期となった。',
    quiz: {
      statement: '800年、カール大帝はローマ教皇から西ローマ皇帝の帝冠を受けた。',
      answer: true,
      explain: 'クリスマスの日、教皇レオ3世がカールに戴冠しました。ゲルマンの王権・ローマの伝統・キリスト教会が結びつき、西ヨーロッパ世界の枠組みができます。',
    },
  },
  {
    id: 'cordoba-mezquita',
    name: 'コルドバのメスキータ',
    nameEn: 'Mosque–Cathedral of Córdoba',
    lat: 37.8790, lng: -4.7794, elevationM: 105,
    region: 'europe', era: 'medieval',
    country: 'スペイン（アンダルシア州）',
    civilization: '後ウマイヤ朝',
    yearLabel: '785年 創建 / 13世紀に大聖堂へ改築',
    whcYear: 1984,
    emoji: '🕌',
    summary:
      'アッバース朝の革命を逃れてイベリア半島に渡ったウマイヤ家の一族が開いた後ウマイヤ朝の都、コルドバに785年から建てられた大モスク。紅白の二重アーチが林立する礼拝空間は、古代ローマの柱を転用して造られた。10世紀のコルドバは人口数十万を数える西ヨーロッパ最大級の都市で、ギリシアの哲学・医学がアラビア語を通じて受け継がれ、のちにラテン語へ翻訳されてヨーロッパの12世紀ルネサンスを準備した。1236年のレコンキスタで街が陥ちると、モスクの中心部に大聖堂が組み込まれた。',
    quiz: {
      statement: 'アリストテレスなどギリシアの学問は、イスラーム世界を経由してヨーロッパへ再び伝わった。',
      answer: true,
      explain: 'ギリシアの著作はアラビア語に翻訳されてイスラーム世界で研究され、トレドやシチリアでラテン語に訳されてヨーロッパへ還流しました。',
    },
  },
  {
    id: 'alhambra',
    name: 'アルハンブラ宮殿',
    nameEn: 'Alhambra',
    lat: 37.1761, lng: -3.5881, elevationM: 790,
    region: 'europe', era: 'medieval',
    country: 'スペイン（アンダルシア州）',
    civilization: 'ナスル朝',
    yearLabel: '13〜14世紀',
    whcYear: 1984,
    emoji: '🕌',
    summary:
      'イベリア半島最後のイスラーム王朝であるナスル朝が、グラナダの丘に築いた宮殿。ライオンの中庭やアラベスク文様の漆喰壁、鍾乳石飾りの天井が、イスラーム美術の洗練を伝える。8世紀に始まったキリスト教勢力によるレコンキスタ（国土回復運動）は、1492年にグラナダが陥落してついに完了した。その同じ年、スペイン女王イサベルの支援を受けたコロンブスが大西洋へ出航している。中世の終わりと大航海時代の始まりが、この宮殿の明け渡しと同じ年に重なっている。',
    quiz: {
      statement: 'グラナダが陥落してレコンキスタが完了したのと同じ年に、コロンブスは最初の航海に出発した。',
      answer: true,
      explain: 'ともに1492年の出来事です。イサベル女王はグラナダ攻略の直後にコロンブスの計画を承認し、大西洋への航海が実現しました。',
    },
  },
  {
    id: 'tower-of-london',
    name: 'ロンドン塔',
    nameEn: 'Tower of London',
    lat: 51.5081, lng: -0.0759, elevationM: 10,
    region: 'europe', era: 'medieval',
    country: 'イギリス（ロンドン）',
    civilization: 'ノルマン朝〜',
    yearLabel: '1078年頃 起工（ホワイト・タワー）',
    whcYear: 1988,
    emoji: '🏰',
    summary:
      '1066年のノルマン征服でイングランド王となったウィリアム1世が、ロンドン市民を威圧するために築いた城塞。中核のホワイト・タワーは1078年頃の起工である。ノルマン征服は大陸の封建制をイングランドに持ち込み、フランス語が支配層の言葉となって英語に大量の語彙を残した。その後、王権と貴族の争いのなかで1215年にマグナ・カルタが認められ、議会政治の芽が生まれる。ロンドン塔は王宮であると同時に牢獄でもあり、アン・ブーリンら多くの処刑の舞台となった。',
    quiz: {
      statement: 'ロンドン塔を築いたウィリアム1世は、1066年にノルマンディーからイングランドを征服した。',
      answer: true,
      explain: 'ノルマンディー公ウィリアムはヘースティングズの戦いで勝利しイングランド王となりました。これがノルマン征服で、英語と社会構造に大きな影響を残します。',
    },
  },
  {
    id: 'chartres-cathedral',
    name: 'シャルトル大聖堂',
    nameEn: 'Chartres Cathedral',
    lat: 48.4478, lng: 1.4875, elevationM: 155,
    region: 'europe', era: 'medieval',
    country: 'フランス（ウール＝エ＝ロワール県）',
    civilization: 'ゴシック建築／カペー朝',
    yearLabel: '1194年 再建着工 / 1220年頃 ほぼ完成',
    whcYear: 1979,
    emoji: '⛪',
    facts: [
      { label: 'ステンドグラス', value: '12〜13世紀の原物が約170窓' },
    ],
    summary:
      'パリの南西約80kmに立つゴシック建築の代表作。1194年の火災の後わずか四半世紀ほどで再建され、様式が一貫している点で貴重である。尖頭アーチ、リブ・ヴォールト、フライング・バットレスによって壁の重さを外へ逃がし、大きなステンドグラスから光が差し込む高い内部空間を実現した。「シャルトル・ブルー」と呼ばれる青の窓は、文字を読めない人々に聖書の物語を伝える「石と光の聖書」でもあった。ゴシックは12世紀以降の都市の成長と商工業の富を背景に、パリのノートルダムなどとともに各地へ広がっていく。',
    quiz: {
      statement: 'ゴシック建築は、厚い壁と小さな窓、半円アーチを特徴とする様式である。',
      answer: false,
      explain: 'それはロマネスク建築の特徴です。ゴシックは尖頭アーチとフライング・バットレスで壁を薄くし、大きなステンドグラスと高い天井を実現しました。',
    },
  },
  {
    id: 'san-marco-venice',
    name: 'ヴェネツィア サン・マルコ広場',
    nameEn: 'Piazza San Marco, Venice',
    lat: 45.4341, lng: 12.3388, elevationM: 2,
    region: 'europe', era: 'medieval',
    country: 'イタリア（ヴェネト州）',
    civilization: 'ヴェネツィア共和国',
    yearLabel: '9世紀〜18世紀（サン・マルコ寺院は11世紀）',
    whcYear: 1987,
    emoji: '⛵',
    summary:
      '干潟の上に築かれた海洋都市国家ヴェネツィアの中心。東方との交易で富を築き、ビザンツ様式のモザイクで飾られたサン・マルコ寺院は、その東方とのつながりを物語る。1204年の第4回十字軍では、ヴェネツィアの主導でコンスタンティノープルが攻略され、ラテン帝国が建てられた。以後ヴェネツィアは東地中海の交易を握り、ドゥカート金貨は国際通貨として流通した。しかし新航路の開拓とオスマン帝国の進出によって、その地位はしだいに失われていく。',
    quiz: {
      statement: '第4回十字軍は、ヴェネツィア商人の意向もあって同じキリスト教国のコンスタンティノープルを攻撃した。',
      answer: true,
      explain: '1204年、十字軍はコンスタンティノープルを占領しラテン帝国を建てました。商業的利害が宗教的目的を上回った例として知られています。',
    },
  },
  {
    id: 'florence-duomo',
    name: 'フィレンツェ大聖堂',
    nameEn: 'Florence Cathedral (Duomo)',
    lat: 43.7731, lng: 11.2560, elevationM: 50,
    region: 'europe', era: 'earlymodern',
    country: 'イタリア（トスカーナ州）',
    civilization: 'ルネサンス／メディチ家',
    yearLabel: '1436年 大円蓋（クーポラ）完成',
    whcYear: 1982,
    whcNote: '「フィレンツェ歴史地区」の一部',
    emoji: '⛪',
    summary:
      '直径約43mの大円蓋は、ブルネレスキが古代ローマのパンテオンを研究し、木製の支保工なしに二重殻構造で積み上げたもので、1436年に完成した。毛織物業と金融で栄えたフィレンツェでは、メディチ家が芸術家を保護し、ダンテ、ボッティチェリ、レオナルド、ミケランジェロらが活躍した。神中心の中世的世界観から、古典古代に学びつつ人間そのものを見つめ直す動きが広がる。この円蓋は、技術と芸術と商業の富が結び合ったルネサンスの精神を、一つの形にした建築である。',
    quiz: {
      statement: 'フィレンツェ大聖堂の大円蓋を設計したのは、ミケランジェロである。',
      answer: false,
      explain: '設計はブルネレスキで、1436年に完成しました。ミケランジェロは約1世紀後の人物で、ローマのサン・ピエトロ大聖堂のドームを手がけています。',
    },
  },
  {
    id: 'st-peters-basilica',
    name: 'サン・ピエトロ大聖堂',
    nameEn: "St. Peter's Basilica",
    lat: 41.9022, lng: 12.4539, elevationM: 40,
    region: 'europe', era: 'earlymodern',
    country: 'バチカン市国',
    civilization: 'ローマ・カトリック教会',
    yearLabel: '1506年 起工 / 1626年 完成',
    whcYear: 1984,
    emoji: '⛪',
    summary:
      '使徒ペテロの墓の上に建つとされる、カトリックの総本山。1506年に教皇ユリウス2世が改築を始め、ブラマンテ、ラファエロ、ミケランジェロらが関わって1626年に完成した。その巨費を賄うためにドイツで贖宥状（免罪符）が大々的に売られたことが、1517年のルターの九十五カ条の論題を招き、宗教改革の直接の引き金となった。ヨーロッパのキリスト教世界はこれを境にカトリックとプロテスタントに分かれ、以後の政治・戦争・国家形成のあり方を大きく変えていく。',
    quiz: {
      statement: 'サン・ピエトロ大聖堂の改築費用を賄うための贖宥状（免罪符）販売が、宗教改革の引き金となった。',
      answer: true,
      explain: 'ドイツでの贖宥状販売に抗議して、1517年にルターが九十五カ条の論題を掲げました。これが宗教改革の始まりとされています。',
    },
  },
  {
    id: 'wittenberg',
    name: 'ヴィッテンベルク城教会',
    nameEn: "All Saints' Church, Wittenberg",
    lat: 51.8665, lng: 12.6382, elevationM: 70,
    region: 'europe', era: 'earlymodern',
    country: 'ドイツ（ザクセン＝アンハルト州）',
    civilization: '宗教改革',
    yearLabel: '1517年 九十五カ条の論題',
    whcYear: 1996,
    whcNote: '「アイスレーベンとヴィッテンベルクのルター記念建造物群」の一部',
    emoji: '⛪',
    summary:
      '1517年、マルティン・ルターがこの教会の扉に九十五カ条の論題を掲げたと伝えられる。贖宥状への抗議から始まった主張は「人は信仰によってのみ義とされる」という原理に立ち、聖書のみを権威とした。ちょうど半世紀ほど前にグーテンベルクが実用化した活版印刷が、その文書を数週間でドイツ中に広めた。ルターによるドイツ語訳聖書は、民衆が自ら聖書を読む道を開くとともに、近代ドイツ語の基礎ともなった。宗教改革はカルヴァンらに引き継がれ、ヨーロッパの秩序を根本から揺さぶった。',
    quiz: {
      statement: 'ルターの主張が短期間でドイツ中に広まった背景には、活版印刷術の普及があった。',
      answer: true,
      explain: '15世紀半ばにグーテンベルクが実用化した活版印刷により、パンフレットが大量に安く刷られ、ルターの主張は数週間で各地へ届きました。',
    },
  },
  {
    id: 'versailles',
    name: 'ヴェルサイユ宮殿',
    nameEn: 'Palace of Versailles',
    lat: 48.8049, lng: 2.1204, elevationM: 130,
    region: 'europe', era: 'earlymodern',
    country: 'フランス（イヴリーヌ県）',
    civilization: 'ブルボン朝（絶対王政）',
    yearLabel: '1682年 ルイ14世が宮廷を移す',
    whcYear: 1979,
    emoji: '👑',
    summary:
      'ルイ14世が父の狩猟用の館を大改築し、1682年に宮廷を移した。鏡の間や広大な幾何学式庭園は、太陽王を中心とする秩序を目に見える形にしたものである。王は貴族を宮廷に住まわせて儀礼に縛りつけ、地方の実権を奪って絶対王政を完成させた。その一方、度重なる戦争とナントの王令廃止による商工業者の流出が財政を蝕んでいく。1789年10月、パリの民衆が宮殿へ押し寄せて国王一家をパリへ連れ戻し、絶対王政は終わった。1919年にはここでヴェルサイユ条約が調印されている。',
    quiz: {
      statement: 'ヴェルサイユ宮殿の鏡の間では、第一次世界大戦の講和条約が調印された。',
      answer: true,
      explain: '1919年、鏡の間でヴェルサイユ条約が調印されました。同じ場所は1871年にドイツ帝国の成立が宣言された場所でもあり、両国の因縁の舞台です。',
    },
  },
  {
    id: 'bastille',
    name: 'バスティーユ広場',
    nameEn: 'Place de la Bastille',
    lat: 48.8532, lng: 2.3692, elevationM: 40,
    region: 'europe', era: 'modern',
    country: 'フランス（パリ）',
    civilization: 'フランス革命',
    yearLabel: '1789年7月14日 バスティーユ牢獄襲撃',
    whcYear: null,
    emoji: '🗼',
    summary:
      'かつてここに立っていたバスティーユ牢獄は、国王が令状ひとつで人を投獄できる絶対王政の象徴だった。1789年7月14日、パリの民衆が武器を求めて襲撃し、要塞は解体される。第三身分が国民議会を名乗り、人権宣言が採択され、やがて王政は倒れた。革命が掲げた自由・平等・国民主権の理念は、ナポレオンの遠征とともにヨーロッパ中へ運ばれ、各地の国民国家形成を促した。7月14日は今もフランスの国民の祝日であり、広場の中央には七月革命を記念する円柱が立つ。',
    quiz: {
      statement: 'バスティーユ牢獄が襲撃された1789年7月14日は、現在もフランスの国民の祝日である。',
      answer: true,
      explain: '7月14日はフランス革命の始まりを記念する日で、パリでは軍事パレードが行われます。日本では「パリ祭」の名でも知られています。',
    },
  },
  {
    id: 'westminster',
    name: 'ウェストミンスター宮殿',
    nameEn: 'Palace of Westminster',
    lat: 51.4995, lng: -0.1248, elevationM: 10,
    region: 'europe', era: 'modern',
    country: 'イギリス（ロンドン）',
    civilization: '議会政治',
    yearLabel: '現在の建物は1840〜1870年代',
    whcYear: 1987,
    emoji: '🏛',
    summary:
      'イギリス議会の議事堂。中世以来ここで議会が開かれてきた。13世紀のシモン＝ド＝モンフォールの議会に始まり、二院制が定着し、17世紀のピューリタン革命と名誉革命を経て「王は君臨すれども統治せず」の原則が固まった。1689年の権利章典は議会主権を明文化し、以後のヨーロッパやアメリカの立憲政治の手本となる。現在の建物は1834年の火災後にゴシック・リヴァイヴァル様式で建て直されたもので、時計塔（エリザベス・タワー）の鐘はビッグ・ベンの名で知られる。',
    quiz: {
      statement: '1689年の権利章典は、国王に対する議会の優位を明文化したものである。',
      answer: true,
      explain: '名誉革命の結果として制定され、国王が議会の同意なく法を停止したり課税したりできないことを定めました。立憲君主政の基礎となります。',
    },
  },
  {
    id: 'ironbridge',
    name: 'アイアンブリッジ峡谷',
    nameEn: 'Ironbridge Gorge',
    lat: 52.6274, lng: -2.4855, elevationM: 45,
    region: 'europe', era: 'modern',
    country: 'イギリス（シュロップシャー）',
    civilization: '産業革命',
    yearLabel: '1779年 世界初の鉄橋が架かる',
    whcYear: 1986,
    emoji: '🌉',
    summary:
      'セヴァーン川に架かる、1779年完成の世界初の鉄橋。この谷ではダービー家がコークスを用いた製鉄法を確立し、良質で安価な鉄が大量に得られるようになった。石炭・鉄・蒸気機関という三つの要素が結びついて、綿工業から始まった産業革命は交通と重工業へ広がっていく。手工業から工場制機械工業への転換は、都市への人口集中、労働問題、そして資本家と労働者という新しい階級の対立を生んだ。近代社会の骨格がここから形づくられていったことを示す産業遺産である。',
    quiz: {
      statement: '産業革命期にコークスを用いた製鉄法が確立し、安価な鉄が大量に得られるようになった。',
      answer: true,
      explain: 'ダービー父子がコークス製鉄法を実用化しました。木炭に頼らずに済むことで鉄の生産量が飛躍的に伸び、機械や鉄道の普及を支えました。',
    },
  },
  {
    id: 'winter-palace',
    name: '冬宮（エルミタージュ美術館）',
    nameEn: 'Winter Palace',
    lat: 59.9398, lng: 30.3146, elevationM: 5,
    region: 'europe', era: 'modern',
    country: 'ロシア（サンクトペテルブルク）',
    civilization: 'ロマノフ朝／ロシア革命',
    yearLabel: '1762年 完成 / 1917年 十月革命の舞台',
    whcYear: 1990,
    whcNote: '「サンクトペテルブルク歴史地区と関連建造物群」の一部',
    emoji: '🏛',
    summary:
      'ピョートル1世が「西欧への窓」として建設した都に、バロック様式で建てられたロマノフ朝の宮殿。エカチェリーナ2世が集めた美術品が、のちのエルミタージュ美術館の基礎となった。1905年、平和的な請願に向かった民衆が宮殿前で銃撃された「血の日曜日事件」は第一次ロシア革命の発端となる。1917年、二月革命で帝政が倒れたのち、十月革命でボリシェヴィキが臨時政府の拠点だったこの宮殿を占拠した。世界初の社会主義政権が生まれ、20世紀の冷戦へとつながっていく。',
    quiz: {
      statement: 'ロシア革命では、二月革命で帝政が倒れ、十月革命でボリシェヴィキが権力を握った。',
      answer: true,
      explain: '1917年3月（ロシア暦2月）の革命でニコライ2世が退位し、同年11月（ロシア暦10月）にレーニン率いるボリシェヴィキが臨時政府を倒しました。',
    },
  },
  {
    id: 'auschwitz',
    name: 'アウシュヴィッツ＝ビルケナウ',
    nameEn: 'Auschwitz-Birkenau',
    lat: 50.0343, lng: 19.1780, elevationM: 230,
    region: 'europe', era: 'modern',
    country: 'ポーランド（小ポーランド県）',
    civilization: '第二次世界大戦・ホロコースト',
    yearLabel: '1940〜1945年',
    whcYear: 1979,
    emoji: '🕯',
    summary:
      'ナチス・ドイツが占領下のポーランドに設けた強制収容所・絶滅収容所。ヨーロッパ各地から貨車で送られた人々がここで選別され、100万人を超える、その大半がユダヤ人である犠牲者が殺害された。ロマ、ポーランド人、ソ連軍捕虜、障害のある人々も対象とされた。人種主義に基づく差別が、官僚機構と鉄道網、そして工業技術と結びついたとき何が起こりうるのかを示す場所である。1979年に世界遺産となり、その正式名称には「ナチス・ドイツの強制絶滅収容所」と加害の主体が明記されている。',
    // 追悼施設: クイズも「NEW!」バッジも出さない。
    solemn: true,
    quiz: null,
  },
  {
    id: 'berlin-wall',
    name: 'ベルリンの壁（イーストサイド・ギャラリー）',
    nameEn: 'Berlin Wall, East Side Gallery',
    lat: 52.5050, lng: 13.4394, elevationM: 35,
    region: 'europe', era: 'modern',
    country: 'ドイツ（ベルリン）',
    civilization: '冷戦',
    yearLabel: '1961年 建設 / 1989年11月9日 開放',
    whcYear: null,
    emoji: '🧱',
    summary:
      '第二次世界大戦後、ドイツは米英仏ソに分割占領され、東側の中に浮かぶ島のようになった西ベルリンへ東側から人が流出し続けた。これを止めるため、1961年に東ドイツが一夜にして築いたのがベルリンの壁である。以後28年間、壁は東西冷戦のもっとも具体的な象徴となった。1989年、東欧各国の民主化のうねりのなかで11月9日に検問所が開かれ、市民の手で壁は崩された。翌年ドイツは再統一され、1991年にはソ連が解体して冷戦が終わる。壁の一部は野外ギャラリーとして残されている。',
    quiz: {
      statement: 'ベルリンの壁は、東ドイツが西ベルリンへの人口流出を防ぐために築いた。',
      answer: true,
      explain: '西ベルリン経由で西側へ逃れる人が絶えなかったため、東ドイツ政府が1961年に築きました。壁は冷戦の象徴となり、1989年に開放されます。',
    },
  },
  {
    // 出典: https://www.toureiffel.paris/en/the-monument/history
    // 出典: https://whc.unesco.org/en/list/600/
    sources: ['https://www.toureiffel.paris/en/the-monument/history', 'https://whc.unesco.org/en/list/600/'],
    id: 'eiffel-tower',
    name: 'エッフェル塔', nameEn: 'Eiffel Tower',
    lat: 48.8584, lng: 2.2945, elevationM: 35,
    // 高い塔を避け、輪の下端も地表 +350m に置く。
    ringAglM: 600,
    region: 'europe', era: 'modern',
    country: 'フランス（パリ）', civilization: '第三共和政・産業と万国博覧会',
    yearLabel: '1889年 パリ万国博覧会に合わせ完成',
    whcYear: 1991, whcNote: '「パリのセーヌ河岸」の一部', emoji: '🗼',
    summary:
      '1889年のパリ万国博覧会に合わせて建てられた鉄の塔。フランス革命から百年の時期に開かれた博覧会で、工業技術の成果を示す存在となった。エッフェルの会社の技術者たちが設計に関わり、大量の鉄の部材を組み合わせて高い構造物を実現した。建設当初はパリの景観に合わないという批判もあり、後世の評価と当時の受け止め方が同じとは限らない。塔は電波通信などにも利用され、観光の象徴であると同時に技術史の一部でもある。空から四本の脚とセーヌ川、シャン・ド・マルスの広がりを見ると、単独の塔ではなく都市の景観を構成する建築だと分かる。メルボルンの王立展示館と結べば、博覧会を通じた技術や文化の交流をたどれる。',
    quiz: {
      statement: 'エッフェル塔は、中世にパリを防衛する見張り塔として建設された。',
      answer: false,
      explain: '1889年の万国博覧会に合わせて建てられました。鉄を使った近代の工業技術や、博覧会の歴史を伝える塔です。',
    },
  },
  {
    // 出典: https://sagradafamilia.org/en/history-of-the-temple
    // 出典: https://whc.unesco.org/en/list/320/
    sources: ['https://sagradafamilia.org/en/history-of-the-temple', 'https://whc.unesco.org/en/list/320/'],
    id: 'sagrada-familia',
    name: 'サグラダ・ファミリア', nameEn: 'Sagrada Família',
    lat: 41.4036, lng: 2.1744, elevationM: 30,
    ringAglM: 450,
    region: 'europe', era: 'modern',
    country: 'スペイン（バルセロナ）', civilization: 'カタルーニャのモデルニスモ',
    yearLabel: '1882年 着工 / 1883年 ガウディが設計を引き継ぐ',
    whcYear: 2005, whcNote: '「アントニ・ガウディの作品群」へ生誕のファサードと地下聖堂を追加登録', emoji: '⛪',
    summary:
      '1882年に工事が始まり、翌年にアントニ・ガウディが設計を引き継いだバルセロナの教会。尖塔や彫刻にはキリスト教の物語が表される一方、内部の柱などには樹木を思わせる形が使われ、自然の観察と構造の工夫が結び付いている。中世の教会に似た要素があっても、工事が始まったのは近代である。ガウディの死後も後の世代が事業を受け継いだ。世界遺産に含まれるのは教会全体ではなく、生誕のファサードと地下聖堂で、登録範囲にも注意したい。上空から周辺の規則的な街区と教会の配置を眺めれば、特徴的な建築が計画都市の中に置かれていることが分かる。建築の見た目、建設年代、保護の対象を分けて考える練習になる。',
    quiz: {
      statement: 'サグラダ・ファミリアは、教会全体が世界遺産の登録対象になっている。',
      answer: false,
      explain: '登録対象は生誕のファサードと地下聖堂です。作品群への追加登録は2005年で、建物全体の登録とは区別されます。',
    },
  },
  {
    // 出典: https://whc.unesco.org/en/list/292/
    sources: ['https://whc.unesco.org/en/list/292/'],
    id: 'cologne-cathedral',
    name: 'ケルン大聖堂', nameEn: 'Cologne Cathedral',
    lat: 50.9413, lng: 6.9583, elevationM: 50,
    ringAglM: 450,
    region: 'europe', era: 'medieval',
    country: 'ドイツ（ケルン）', civilization: '中世のキリスト教・19世紀の再開事業',
    yearLabel: '1248年 着工 / 1880年 完成',
    whcYear: 1996, emoji: '⛪',
    summary:
      '1248年に建設が始まったゴシック様式の大聖堂で、長い中断を挟み、完成したのは1880年である。高い天井や大きな窓、二本の尖塔は、中世以来の信仰と建築技術を伝える。19世紀の工事でも中世の計画が参照されたため、外観が一体的でも、すべてが同じ時代に造られたわけではない。建設には多くの世代の職人や支援者が関わり、文化財が長期の共同作業で生まれることを示している。ライン川に近く、現在は鉄道駅にも隣接するため、空から宗教の中心と交通の要所が重なる都市の姿を見られる。京都や奈良の寺院と比べれば、建材や屋根の形が違っても、再建や継承によって歴史を伝えるという共通点に気付ける。',
    quiz: {
      statement: 'ケルン大聖堂は、中世に着工したが、完成したのは19世紀である。',
      answer: true,
      explain: '着工は1248年、完成は1880年です。中断と再開を経ており、見た目の様式と建設された年代は必ずしも一致しません。',
    },
  },
  {
    // 出典: https://whc.unesco.org/en/list/616/
    sources: ['https://whc.unesco.org/en/list/616/'],
    id: 'prague-castle',
    name: 'プラハ城（聖ヴィート大聖堂）', nameEn: 'Prague Castle',
    lat: 50.0909, lng: 14.4005, elevationM: 255,
    region: 'europe', era: 'medieval',
    country: 'チェコ（プラハ）', civilization: 'ボヘミア王国・神聖ローマ帝国',
    yearLabel: '中世以降 城と聖堂を拡張・改築',
    whcYear: 1992, whcNote: '「プラハ歴史地区」の一部', emoji: '🏰',
    summary:
      'ヴルタヴァ川の西側の丘に広がる城で、ボヘミアの王たちが政治と宗教の中心として整えてきた。城内には宮殿だけでなく聖ヴィート大聖堂などの宗教施設があり、時代ごとの増築や改修によって多様な建築が集まる。プラハは神聖ローマ帝国とも深く関わり、中欧の文化や学問の交流拠点となった。城を一つの天守として想像すると実際の姿を捉えにくく、長い歴史をもつ建築群として見ることが大切である。上空から丘の城、川に架かる橋、対岸の旧市街を順にたどれば、防御・交通・商業が結ばれた都市の構造が分かる。江戸城や仙台城と比較して、地形を利用するという共通点と、城内に大聖堂を置くという違いを考えられる。',
    quiz: {
      statement: 'プラハ城は、一棟の天守だけで構成され、城内に宗教施設はない。',
      answer: false,
      explain: '宮殿や聖ヴィート大聖堂などが集まる建築群です。「城」という同じ言葉でも、地域によって構成は異なります。',
    },
  },
  {
    // 出典: https://whc.unesco.org/en/list/786/
    sources: ['https://whc.unesco.org/en/list/786/'],
    id: 'schonbrunn-palace',
    name: 'シェーンブルン宮殿', nameEn: 'Schönbrunn Palace',
    lat: 48.1845, lng: 16.3122, elevationM: 190,
    region: 'europe', era: 'earlymodern',
    country: 'オーストリア（ウィーン）', civilization: 'ハプスブルク家・マリア・テレジア',
    yearLabel: '18世紀 宮殿と庭園を整備',
    whcYear: 1996, emoji: '🏰',
    summary:
      'ハプスブルク家の夏の離宮として使われ、特に18世紀のマリア・テレジアの時代に整えられた宮殿と庭園。大きな建物や豪華な室内は、王家の生活だけでなく、外交や儀式を通して権威を示す場でもあった。宮殿の背後には幾何学的に配置された花壇や並木道が広がり、建築と庭園が共通の軸に沿ってつながる。自然をそのまま残した庭ではなく、人が秩序ある風景を設計した点が特徴である。上空から宮殿、庭園、丘の上の建築を見渡すと、地上ではつかみにくい全体の構成が明瞭になる。ヴェルサイユ宮殿や日本の大名庭園と比べれば、近世の支配者が風景をどのように文化や権力の表現として用いたかを考えられる。',
    quiz: {
      statement: 'シェーンブルンでは、宮殿と庭園を一体として設計した配置が見られる。',
      answer: true,
      explain: '建築と庭園の軸や幾何学的な配置が結び付いています。上空から見ると、空間全体の設計を読み取りやすくなります。',
    },
  },
  {
    // 出典: https://www.berlin.de/en/attractions-and-sights/3560266-3104052-brandenburg-gate.en.html
    sources: ['https://www.berlin.de/en/attractions-and-sights/3560266-3104052-brandenburg-gate.en.html'],
    id: 'brandenburg-gate',
    name: 'ブランデンブルク門', nameEn: 'Brandenburg Gate',
    lat: 52.5163, lng: 13.3777, elevationM: 35,
    region: 'europe', era: 'modern',
    country: 'ドイツ（ベルリン）', civilization: 'プロイセン・冷戦とドイツ統一',
    yearLabel: '1791年 完成',
    whcYear: null, emoji: '🏛',
    summary:
      'プロイセン王フリードリヒ・ヴィルヘルム2世の命で建てられ、1791年に完成した門。設計にはアテネのアクロポリスの入口が参照され、古代ギリシャの建築を近代に取り入れる新古典主義の例となっている。上部の四頭立て馬車像も含め、戦争や政変の中で象徴として扱われてきた。冷戦期にベルリンの壁が築かれると門は立入りを制限された区域に位置し、東西分断の姿を示した。壁が開かれた後は、統一を象徴する場所として受け止められるようになった。空から門と大通り、公園の位置を見ながら、同じ建物でも時代によって意味が変化することを考えたい。近くのベルリンの壁の遺構と合わせてたどると、地図上の境界が暮らしを分けた歴史が見えてくる。',
    quiz: {
      statement: 'ブランデンブルク門は、1989年にベルリンの壁が開かれた後で初めて建設された。',
      answer: false,
      explain: '門の完成は1791年です。冷戦期には分断の象徴となり、その後に統一を象徴する意味が重なりました。',
    },
  },
  {
    // 出典: https://whc.unesco.org/en/list/263/
    sources: ['https://whc.unesco.org/en/list/263/'],
    id: 'belem-tower',
    name: 'ベレンの塔', nameEn: 'Belém Tower',
    lat: 38.6916, lng: -9.2160, elevationM: 3,
    region: 'europe', era: 'earlymodern',
    country: 'ポルトガル（リスボン）', civilization: '大航海時代・マヌエル1世',
    yearLabel: '16世紀初頭 建設',
    whcYear: 1983, whcNote: '「リスボンのジェロニモス修道院とベレンの塔」', emoji: '🏰',
    summary:
      '16世紀初頭、テージョ川の港の入口を守るために築かれた塔。ポルトガルの船が大西洋からアフリカやアジアへ進んだ時代を伝え、近くのジェロニモス修道院とともに世界遺産となっている。塔は船の動きを監視し港を防衛する機能をもちながら、豊かな装飾によって王国の力も表した。大航海時代は航路の拡大や異文化の交流を生んだ一方、武力による支配や搾取も伴った。壮麗な建築を見る際には、どこから富が集まり、誰の労働に支えられたかも考える必要がある。上空から広い河口と塔、市街地の位置を確かめれば、リスボンが海へ開かれた都市だったことが分かる。喜望峰やマラッカの名所と結ぶと、遠い地点が海路でつながる世界史をたどれる。',
    quiz: {
      statement: 'ベレンの塔は、リスボンの港の入口を守る役割も担っていた。',
      answer: true,
      explain: '塔はテージョ川の港を防衛する施設でした。装飾の美しさと、軍事や海上交易に関わる機能の両方をもっています。',
    },
  },
  {
    // 出典: https://whc.unesco.org/en/list/728/
    sources: ['https://whc.unesco.org/en/list/728/'],
    id: 'edinburgh-castle',
    name: 'エディンバラ城', nameEn: 'Edinburgh Castle',
    lat: 55.9486, lng: -3.1999, elevationM: 130,
    region: 'europe', era: 'medieval',
    country: 'イギリス（スコットランド）', civilization: 'スコットランド王国',
    yearLabel: '中世以降 王城・要塞として発展',
    whcYear: 1995, whcNote: '「エディンバラの旧市街と新市街」の一部', emoji: '🏰',
    summary:
      '岩山の上に築かれた城で、スコットランドの王権や軍事の歴史と深く結び付いてきた。周囲より高い位置と急な斜面は、接近する相手を見渡し、防ぐために役立った。城から東へ延びる尾根に旧市街が広がり、細い路地や密集した建物には中世以来の都市の構造が残る。一方、北側の新市街は18世紀以降に計画的に整備され、整った街路が特徴である。「新市街」という名でも、すでに数百年の歴史をもつ点に注目したい。上空から城を中心に二つの町並みを比較すると、自然の地形に沿って育った都市と、計画によって拡張した都市の違いがよく分かる。城だけでなく周囲の街まで一緒に見ることで、世界遺産の景観を立体的に理解できる。',
    quiz: {
      statement: 'エディンバラの新市街は、21世紀になって初めて開発された地区である。',
      answer: false,
      explain: '新市街の整備は18世紀から進められました。「新しい」という呼び名は、比較する時代や相手によって意味が変わります。',
    },
  },
];
